import { render } from "./ExtendedCaseDescription.vue?vue&type=template&id=53a9557c&ts=true"
import script from "./ExtendedCaseDescription.vue?vue&type=script&lang=ts"
export * from "./ExtendedCaseDescription.vue?vue&type=script&lang=ts"

import "./ExtendedCaseDescription.vue?vue&type=style&index=0&id=53a9557c&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__